import { DesignSystem } from '@/src/design-system'
import { useContentCards } from '@/src/services/Braze/useContentCards'

export function BrazeContentCards({ placement }: { placement: 'home' }) {
  const contentCards = useContentCards(placement)

  if (contentCards.length === 0) {
    return null
  }

  return (
    <>
      {contentCards.map((contentCard) => (
        <DesignSystem.BrazeContentCard key={contentCard.id} contentCard={contentCard} />
      ))}
    </>
  )
}
